import { render, staticRenderFns } from "./createCommand.vue?vue&type=template&id=62198ce3&scoped=true"
import script from "./createCommand.vue?vue&type=script&lang=js"
export * from "./createCommand.vue?vue&type=script&lang=js"
import style0 from "./createCommand.vue?vue&type=style&index=0&id=62198ce3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62198ce3",
  null
  
)

export default component.exports